/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

/* eslint-disable react/no-this-in-sfc */
import { STAY_DATE_END_DATE, STAY_DATE_START_DATE } from 'modules/common/constants/date-range';
import { Grid } from '@mui/material';
import { DateRange } from 'react-date-range';
import { useSelector } from 'react-redux';
import { TextField } from './style';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { selectAppTheme } from '../../../dashboard/selectors';
import variants from '../../theme/variants';

/**
 * Custom stay date range picker common component that uses across modules for select stay date range
 * @param {Function} handleChange - function for setting data range
 * @param {Array} ranges - start date and end data of the picker
 * @param {String} label - textfield label
 * @param {String} adornment - whether we need to adornment is beginning or not
 * @param {String} dateValue - selected date value
 * @param {String} cssClassName - use style for entire component
 * @param {Boolean} isSaveDisabled - To show preset max count info
 * @returns
 */
const CustomPresetStayDateRangePicker = (props) => {
  // destruct the props object
  const { handleChange, ranges, dateValue, cssClassName } = props;
  //
  const themeName = useSelector(selectAppTheme);
  const selectedVariant = variants.find((variant) => variant.name === themeName);

  // checks the range is exited or not and set date range
  const dateRange =
    ranges !== null
      ? [
          {
            startDate: new Date(ranges[0].startDate),
            endDate: new Date(ranges[0].endDate),
            key: 'selection',
            color: selectedVariant?.palette.primary.main,
          },
        ]
      : [
          {
            startDate: new Date(),
            endDate: new Date(),
            key: 'selection',
            color: selectedVariant?.palette.primary.main,
          },
        ];
  //
  return (
    <Grid container flexDirection="row" justifyContent="space-between" spacing={2}>
      <Grid item xs={5}>
        <TextField
          label="Date Range"
          my={5}
          value={dateValue}
          size="small"
          color="primary"
          fullWidth
        />
      </Grid>
      <Grid item mt={5}>
        <DateRange
          onChange={handleChange}
          editableDateInputs
          moveRangeOnFirstSelection={false}
          ranges={dateRange}
          months={1}
          direction="horizontal"
          className={cssClassName}
          maxDate={new Date(STAY_DATE_END_DATE)}
          minDate={new Date(STAY_DATE_START_DATE)}
          dateDisplayFormat="yyyy-MM-dd"
        />
      </Grid>
    </Grid>
  );
};
//
export default CustomPresetStayDateRangePicker;
